/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Vietnamese (Vietnam)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Nhóm • 50+ thành viên',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Nhóm • 50+ thành viên, bao gồm cả bạn',
  'fabric.elements.mentions.team.member.count': '{0, plural, other {Nhóm • {0} thành viên}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, other {Nhóm • {0} thành viên, bao gồm cả bạn}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Cần quyền truy cập vào Confluence',
  'fabric.mention.error.defaultAction': 'Hãy thử lại trong vài giây',
  'fabric.mention.error.defaultHeadline': 'Đã xảy ra lỗi',
  'fabric.mention.error.differentText': 'Hãy thử nhập văn bản khác',
  'fabric.mention.error.loginAgain': 'Hãy thử đăng xuất, sau đó đăng nhập lại',
  'fabric.mention.noAccess.label': 'Không có quyền truy cập',
  'fabric.mention.noAccess.warning': '{name} sẽ không được thông báo vì họ không có quyền truy cập',
  'fabric.mention.unknow.user.error': '{userId} người dùng không xác định'
};